export const formatPhoneNumber = (value: string): string => {
  const digits = value.replace(/\D/g, "");
  return digits.replace(/(\d{3})(\d{0,7})/, (match, p1, p2) => {
    return `${p1}-${p2}`.replace(/-$/, "");
  });
};
